import { createBlock, mergeBlock } from "@easy-email-pro-core/utils";

import { ElementCategory } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  Element,
  StandardTextElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { Text } from "@easy-email-pro-core/components";
import { omit } from "lodash";

export const generateTextBlock = <T extends Element>(
  element: T & { name: string },
  defaultData: ElementDefinition<T>["defaultData"]
) => {
  return createBlock({
    get name() {
      return element.name;
    },
    defaultData: defaultData,
    type: element.type,
    create: (payload) => {
      return mergeBlock(omit(element, ["name"]) as unknown as T, payload);
    },
    category: ElementCategory.TEXT,
    render(params) {
      const { node } = params;

      const attributes = mergeBlock(
        node.attributes,
        element.attributes
      ) as StandardTextElement["attributes"];

      if (attributes.direction === "rtl") {
        if (!attributes["css-class"]) {
          attributes["css-class"] = "";
        }
        attributes["css-class"] = attributes["css-class"] + " direction-rtl";
      }

      return (
        <Text {...attributes} idx={params.idx}>
          {params.children || node.children}
        </Text>
      );
    },
  });
};
